<template>
  <div id="graph-maintenance" class="interval-with-header">
    <div class="ef--inner">
      <div class="gm-desition">
        <li class="gmc-desition-button-item">
          <button class="bt-cyan" @click="onBack()">戻る</button>
        </li>
        <ul class="gm-desition-button">
          <li class="gm-desition-button-item">
            <button class="gm-bt-scale" @click="onScaleGroup()">
              スケールグループ設定
            </button>
          </li>

          <li class="gm-desition-button-item">
            <button class="bt-cyan" @click="onSave()">保存</button>
          </li>
        </ul>
      </div>
      <ul class="filter-condition-list">
        <li class="filter-condition-list-item">
          グラフ名称&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <input :id="'graph_name'" type="text" class="input-field text-box" v-model="graphName"
            name="representative_graph_name" placeholder="設定時必須項目" v-validate="'max:32'" data-vv-as="グラフ名称" />
          <div class="err_message">
            {{ errors.first("representative_graph_name") }}
          </div>
        </li>
        <li class="gm-shoki">
          <label>初期表示設定&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
        </li>
        <li class="gm-shoki">単位：</li>
        <li>
          <div name="unit" class="gm-dropdown gm-shoki gm-shoki-item">
            <select :id="'init_interval'" v-model="selectInterval">
              <option v-for="(option, index) in initIntervalList" v-bind:key="index" v-bind:value="option.init_interval">
                {{ option.init_interval }}
              </option>
            </select>
          </div>
        </li>
        <li class="gm-shoki">&nbsp;&nbsp;&nbsp;&nbsp;範囲：</li>
        <li>
          <div class="gm-dropdown gm-shoki gm-shoki-item">
            <select :id="'init_period'" v-model="selectPeriod">
              <option v-for="(option, index) in PeriodList" v-bind:key="index" v-bind:value="option.name">
                {{ option.name }}
              </option>
            </select>
          </div>
        </li>
      </ul>
      <ul class="filter-condition-list">
        <li class="filter-condition-list-item">
          気温・気象表示 &nbsp;
          <div class="gm-select-box">
            <select :id="'weather_area_name'" v-model="weatherAreaName">
              <option></option>
              <option v-for="(weatherAreaInfo, index) in weatherAreaInfoList" v-bind:key="index">
                {{ weatherAreaInfo.area_name }}
              </option>
            </select>
          </div>
        </li>
        <ul class="gm-desition-button"></ul>
      </ul>
    </div>

    <!-- 表 -->
    <div class="gm-maincont">
      <div class="ef--inner">
        <h2>グラフ設定</h2>
        <div class="gm-parent-account-list-container">
          <table class="gm-normal-table gm-table" _fixedhead="rows:1;cols:0;">
            <thead>
              <tr>
                <th>No.</th>
                <th class="gm-area-name">エリア名称</th>
                <th>データコード</th>
                <th class="gm-table-name">名称</th>
                
                <th class="gm-percent-graph-name">工程名称</th>
                <th class="gm-percent">割合(%)</th>

                <th>単位</th>
                <th>スケールグループ</th>
                <th class="gm-table-tooltip">ツールチップ項目表示</th>
                <th>グラフ種類</th>
                <th class="gm-table-color">色</th>
                <th v-if="graphId">削除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(graph, index) in graphItemSettingsList" v-bind:key="index">
                <td>
                  {{ index + 1 }}
                  <!-- グラフ項目ID（非表示） -->
                  <div class="graph_item_id_hidden_area" hidden>
                    <input :id="'graph_item_id_' + index" v-model="selectedGraphItemIdList[index]">
                  </div>
                </td>

                <!-- エリア名称 -->
                <td>
                  <div class="gm-dropdown">
                    <!-- ユーザが選択したエリア名称をv-modelに入れ、データコード列の選択肢の準備のため@change実行 -->
                    <select :id="'area_name_' + index" v-model="selectedAreaNameList[index]"
                      @change="onSelectAreaName(index)">
                      <option value='' disabled selected style='display:none;'>設定時必須項目</option>
                      <option></option>
                      <!-- areaInfoListの配列のarea_name項目を選択肢として全表示 -->
                      <option v-for="(areaInfo, aaa) in areaInfoList" v-bind:key="aaa">
                        {{ areaInfo.area_name }}
                      </option>
                    </select>
                  </div>
                </td>

                <!-- データコード -->
                <td>
                  <div class="gm-dropdown">
                    <!-- ユーザが選択したデータコードをv-modelに入れ、名称・単位列の表示のため@change実行 -->
                    <select :id="'data_code_' + index" v-model="selectedDataCodeList[index]"
                      @change="onSelectDataCode(index)">
                      <option value='' disabled selected style='display:none;'>設定時必須項目</option>
                      <option></option>
                      <!-- selectedDataInfo1の配列の要素を選択肢として全表示 -->
                      <option v-for="(dataCode, bbb) of filteredDataCodeList[index]" v-bind:key="bbb">
                        {{ dataCode }}
                      </option>
                    </select>
                  </div>
                </td>

                <!-- データ名称 -->
                <td :id="'data_name_' + index">
                  {{ identifiedDataNameList[index] }}
                </td>

                <!-- 工程名称 -->
                <td>
                  <input :id="'percent_graph_name_' + index" v-model="percentGraphNameList[index]" type="text" class="percent-graph-name">
                </td>

                <!-- 割合 -->
                <td>
                  <input :id="'percent_' + index" v-model="percentList[index]" type="number" class="percent">
                </td>

                <!-- 単位 スケールグループ列の選択肢の準備のため@change実行-->
                <td :id="'unit_name_' + index">
                  {{ identifiedUnitNameList[index] }}
                </td>

                <!-- スケールグループ -->
                <td>
                  <div class="gm-dropdown">
                    <!-- ユーザが選択したスケールグループをv-modelに入れる -->
                    <select :id="'scale_group_name_' + index" v-model="selectedScaleGroupList[index]"> >
                      <option></option>
                      <!-- selectedDataInfo1の配列の要素を選択肢として全表示 -->
                      <option v-for="(scaleGroup, ccc) of filteredScaleGroupList[index]" v-bind:key="ccc">
                        {{ scaleGroup }}
                      </option>
                    </select>
                  </div>
                </td>

                <!-- ツールチップ項目表示 -->
                <td>
                  <label><input :id="'is_tooltip_' + index" type="checkbox" :checked="graph.is_tooltip" /></label>
                </td>

                <!-- グラフ種類 -->

                <td>
                  <div class="gm-dropdown">
                    <select :id="'graph_kind_' + index" v-model="selectedGraphKindList[index]">
                      <option v-for="(option, index) in graphKindListItems" v-bind:key="index">
                        {{ option.graph_kind }}
                      </option>
                    </select>
                  </div>
                </td>

                <!-- 色 -->
                <td>
                  <input type="text" :id="'graph_color_' + index" :name=index v-model="selectedGraphColorList[index]"
                    hidden>
                </td>

                <!-- 削除 -->
                <td v-if="graphId">
                  <label><input type="checkbox" :id="'is_delete_' + index" /></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//* eslint-disable */

export default {
  name: "McmsGraphMaintenance",

  components: {},

  data: function () {
    //入れ物を定義
    return {
      accountId: "",
      UnitInfoList: [],
      graphId: null,
      graphName: null,
      initPeriod: null,
      initInterval: null,
      weatherAreaName: null,
      areaInfoList: [],
      weatherAreaInfoList: [],
      dataInfoList: [],
      scaleInfoList: [],
      graphItemSettingsList: [],

      //DBからとってきたデータ（入力チェック用）
      initGraphName: "",
      initWeatherAreaName: "",
      //初期表示の単位選択肢
      selectInterval: "",
      initIntervalList: [
        {
          init_interval: "月",
        },
        {
          init_interval: "日",
        },
        {
          init_interval: "時",
        },
        {
          init_interval: "30分",
        },
        {
          init_interval: "分",
        },
      ],
      //初期表示の範囲の選択肢
      PeriodList: [],
      selectPeriod: "",
      initPeriodItem: "",
      items: {
        "月": [{ name: "1か月" }],
        "日": [{ name: "1か月" }, { name: "1週間" }, { name: "1日" }],
        "時": [
          { name: "1か月" },
          { name: "1週間" },
          { name: "1日" },
          { name: "1時間" },
        ],
        "30分": [
          { name: "1か月" },
          { name: "1週間" },
          { name: "1日" },
          { name: "1時間" },
        ],
        "分": [{ name: "1週間" }, { name: "1日" }, { name: "1時間" }],
      },
      //グラフ種類の選択肢
      graphKindListItems: [
        {
          graph_kind: "折れ線",
        },
        {
          graph_kind: "棒",
        },
      ],
      // グラフ項目ごとの、選択されたエリア名称
      selectedGraphItemIdList: [],
      // グラフ項目ごとの、選択されたエリア名称
      selectedAreaNameList: [],
      // グラフ項目ごとの、選択されたエリア名称に紐づくデータコード候補
      filteredDataCodeList: [],
      // グラフ項目ごとの、選択されたデータコード
      selectedDataCodeList: [],
      // グラフ項目ごとの、選択されたデータコードに紐づくデータ名称
      identifiedDataNameList: [],
      // グラフ項目ごとの、工程名称
      percentGraphNameList: [],
      // グラフ項目ごとの、割合
      percentList: [],

      // グラフ項目ごとの、選択されたデータコードに紐づく単位
      identifiedUnitNameList: [],
      identifiedUnitIdList: [],
      // グラフ項目ごとの、出力された単位に紐づく候補
      filteredScaleGroupList: [],
      // グラフ項目ごとの、選択されたデータコード
      // ["温度その1（冷温水）","温度その2（冷温水）","温度その3（冷温水）",]
      selectedScaleGroupList: [],
      // グラフ項目ごとの、選択されたグラフ種類
      selectedGraphKindList: [],
      // グラフ項目ごとの、選択されたグラフ種類の候補
      filteredgraphKindList: [],
      //グラフ項目ごとの選択された色を設定
      ColorList: [
        "#ff0000", "#0000ff", "#32cd32", "#ff1493", "#6a5acd",
        "#00ffff", "#8b0000", "#ffc0cb", "#ff00ff", "#00ff7f",
        "#8b4513", "#03af7A", "#ff6347", "#000080", "#00ff00",
        "#ff69b4", "#ffa500", "#800080", "#8a2be2", "#000000",
        "#008000", "#808080", "#ffd700", "#7cfc00", "#ffff00",
        "#7cfc00", "#d2691e", "#daa520", "#adff2f", "#4b0082",
        "#c0c0c0", "#ee82ee", "#87cefa", "#ffffff",
      ],
      graphKind: "折れ線",
      //グラフ項目ごとの選択された色を設定・色の初期表示
      selectedGraphColorList: [
        "#ff0000", "#0000ff", "#32cd32", "#ff1493", "#6a5acd",
        "#00ffff", "#8b0000", "#ffc0cb", "#ff00ff", "#00ff7f",
        "#8b4513", "#03af7A", "#ff6347", "#000080", "#00ff00",
        "#ff69b4", "#ffa500", "#800080", "#8a2be2", "#000000",
      ],
      getRecordNum: 0,

      //入力チェックデータに入っている初期データ
      test: [],

      //初回画面表示判定用フラグ
      initDisplyFlg: true,
      
      // 割合の負の値および指数入力防止用の正規表現
      regex: new RegExp(/e|E/),
    };
  },

  computed: {},

  watch: {
    //初期表示単位が決まった時に範囲が決まる処理
    selectInterval: function () {
      if (this.initDisplyFlg != true) {
        this.PeriodList = this.items[this.selectInterval];
        this.selectPeriod = this.PeriodList[0].name;
      } else {
        this.initDisplyFlg = false;
      }
    },
    //データコード決まった時にグラフ種類が決まる処理
    selectDataCode: function () {
      this.graphKindList = this.graphKindListitems[this.selectDataCode];
      this.selectGraphKind = this.graphKindList[0].name;
    },
  },

  mounted: async function () {
    let thisUrl = this.$route.path;
    let accountType = thisUrl.split('/')[1];

    if (accountType == 'es') {
      this.accountId = this.$store.state.childID;
    } else if (accountType == 'shop') {
      this.accountId = this.$store.state.parentID;
    } else if (accountType == 'admin') {
      this.accountId = this.$store.state.loginID;
    }

    await this.getGraphMaintenance();
    this.graphColor();

    //「表以外」初期表示設定 単位・範囲 初期値設定
    if (this.$store.state.graphID == null) {
      this.initInterval = "30分";
      this.initPeriod = "1日";
    }
    this.selectInterval = this.initInterval;
    this.selectPeriod = this.initPeriod;
    this.PeriodList = this.items[this.selectInterval];

    this.selectGraphKind = this.GraphKind;
    //「表」エリア名称初期表示・データコード初期表示
    //変更の場合
    if (this.graphName != null) {
      for (let graphItemSettings = 0; graphItemSettings < 20; graphItemSettings++) {
        this.selectedGraphItemIdList[graphItemSettings] = this.graphItemSettingsList[graphItemSettings].graph_item_id;
        this.selectedAreaNameList[graphItemSettings] = this.graphItemSettingsList[graphItemSettings].area_name;
        this.onSelectAreaName(graphItemSettings);
        this.selectedDataCodeList[graphItemSettings] = this.graphItemSettingsList[graphItemSettings].data_code;
        this.selectedScaleGroupList[graphItemSettings] = this.graphItemSettingsList[graphItemSettings].scale_group_name;
        this.onSelectDataCode(graphItemSettings);
        // 工程名称、割合を表示
        this.percentGraphNameList[graphItemSettings] = this.graphItemSettingsList[graphItemSettings].percent_graph_name;
        this.percentList[graphItemSettings] = this.graphItemSettingsList[graphItemSettings].percent;
      }
      //新規の場合
    } else {
      for (let graphItemSettings = 0; graphItemSettings < 20; graphItemSettings++) {
        this.selectedGraphItemIdList[graphItemSettings] = "";
        this.selectedAreaNameList[graphItemSettings] = "";
        this.selectedDataCodeList[graphItemSettings] = "";
        this.selectedScaleGroupList[graphItemSettings] = "";
        // 工程名称、割合に初期値を表示
        this.percentGraphNameList[graphItemSettings] = "";
        this.percentList[graphItemSettings] = 0;
      }
    }
  },

  methods: {
    /* グラフ情報取得API */
    getGraphMaintenance: async function () {

      let urlSessionGraphIdStr = "";
      if (this.$store.state.graphID !== null) {
        urlSessionGraphIdStr = "/" + this.$store.state.graphID;
      }
      await this.$axios
        .get(`/srv/api/multi_circuit_graph_maintenance/${this.accountId}${urlSessionGraphIdStr}`, {
          withCredentials: true,
        })
        .then(response => {
          console.log("============");
          console.log(response.data);
          this.UnitInfoList = response.data.unit_info;
          this.graphId = response.data.graph_id;
          if (response.data.graph_name != null) {
            this.graphName = response.data.graph_name;
          } else {
            this.graphName = "";
          }
          this.initGraphName = this.graphName;
          this.initInterval = response.data.init_interval;
          this.initPeriod = response.data.init_period;
          if (response.data.weather_area_name != null) {
            this.weatherAreaName = response.data.weather_area_name;
          } else {
            this.weatherAreaName = "";
          }
          this.initWeatherAreaName = this.weatherAreaName;
          this.areaInfoList = response.data.area_info;
          this.weatherAreaInfoList = response.data.weather_area_info;
          this.dataInfoList = response.data.data_info;
          if (response.data.scale_info != null) {
            this.scaleInfoList = response.data.scale_info;
          } else {
            this.scaleInfoList = [];
          }
          if (response.data.graph_item_settings != null) {
            this.getRecordNum = response.data.graph_item_settings.length;
            this.graphItemSettingsList = response.data.graph_item_settings;
            for (let i = 0; i < response.data.graph_item_settings.length; i++) {
              if (this.graphItemSettingsList[i].scale_group_name == null) {
                this.graphItemSettingsList[i].scale_group_name = "";
              }
              this.selectedGraphColorList[i] = response.data.graph_item_settings[i].graph_color;
              this.selectedGraphKindList[i] = response.data.graph_item_settings[i].graph_kind;
            }
          } else {
            this.graphItemSettingsList = [];
          }

          // 20行表示させるため、空のjsonを追加
          for (let cnt = this.graphItemSettingsList.length; cnt < 20; cnt++) {
            var emptyGraphItemList = new Object;
            emptyGraphItemList.area_name = "";
            emptyGraphItemList.data_code = "";
            emptyGraphItemList.data_name = "";
            // 工程名称、割合に初期値を表示
            emptyGraphItemList.percent_graph_name = "";
            emptyGraphItemList.percent = 0;
            
            emptyGraphItemList.unit_id = "";
            emptyGraphItemList.unit_name = "";
            emptyGraphItemList.scale_group_name = "";
            emptyGraphItemList.is_tooltip = false;
            emptyGraphItemList.graph_kind = "";
            emptyGraphItemList.graph_color = this.ColorList[cnt];
            this.graphItemSettingsList.push(emptyGraphItemList);
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });

    },

    /* グラフ情報新規API */
    postGraphMaintenance: function (params) {
      this.$axios
        .post(`/srv/api/multi_circuit_graph_maintenance/${this.accountId}`, params, {
          withCredentials: true
        })
        .then(response => {
          this.graphId = response.data.graphId;
          if (response.data.status === "success") {
            this.$store.dispatch("setGraphID", this.graphId);
            alert('保存しました。');
            this.reload(1);
          }
          else {
            // eslint-disable-next-line no-console
            console.error(response.data.status);
            alert('保存に失敗しました。');
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
          alert('保存に失敗しました。');
        });
    },

    /* グラフ情報設定API */
    putGraphMaintenance: function (params) {
      this.$axios
        .put(`/srv/api/multi_circuit_graph_maintenance/${this.accountId}`, params, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status !== undefined) {
            if (response.data.status === "success") {
              alert('保存しました。');
              this.reload(1);
            }
            else {
              // eslint-disable-next-line no-console
              console.error(response.data.status);
              alert('保存に失敗しました。');
            }
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
          alert('保存に失敗しました。');
        });
    },

    // エリア名称選択時作動し、データコードの選択肢を絞る
    onSelectAreaName(index) {
      let dataCodeList = [];
      for (const dataInfo of this.dataInfoList) {
        if (dataInfo.area_name == this.selectedAreaNameList[index]) {
          dataCodeList.push(dataInfo.data_code);
        }
      }
      this.filteredDataCodeList[index] = dataCodeList;
      
      this.selectedDataCodeList[index] = "";  
      this.identifiedDataNameList[index] = "";
      // 工程名称、割合に空白を表示
      this.percentGraphNameList[index] = "";
      this.percentList[index] = 0;

      this.identifiedUnitNameList[index] = "";
      this.identifiedUnitIdList[index] = "";
      this.selectedScaleGroupList[index] = "";

      var tooltip_element = document.getElementById(`is_tooltip_${index}`);
      var color_element = document.getElementById(`graph_color_${index}`);
      var new_area_name = this.selectedAreaNameList[index];
      if(new_area_name == ""){
        this.selectedGraphKindList[index] = "";
        tooltip_element.checked = false;
        if(color_element.previousElementSibling != null){
          this.selectedGraphColorList[index] = document.getElementById(`graph_color_${index}`).value;
          color_element.previousElementSibling.style.display = "none";
        }
      }
    },

    // データコード選択時作動し、データ名称、単位を特定する。 グラフ種類、色も入る。
    onSelectDataCode(index) {
      for (const dataInfo of this.dataInfoList) {
        if (dataInfo.area_name == this.selectedAreaNameList[index]
          && dataInfo.data_code == this.selectedDataCodeList[index]) {
          this.identifiedDataNameList[index] = dataInfo.data_name;
          this.identifiedUnitNameList[index] = dataInfo.unit_name;
          this.identifiedUnitIdList[index] = dataInfo.unit_id;
          //this.selectedGraphKindList[index] = "折れ線";
          break;
        }
      }
      // データコード選択時作動し、単位に紐づいたスケールグループの選択肢を絞る

      let scaleGroupList = [];
      for (const scaleGroupInfo of this.scaleInfoList) {
        if (scaleGroupInfo.unit_id == this.identifiedUnitIdList[index]) {
          scaleGroupList.push(scaleGroupInfo.scale_group_name);
        }
      }
      this.filteredScaleGroupList[index] = scaleGroupList;

      if (this.selectedDataCodeList[index] != "") {
        const str = '#graph_color_';
        let id = str + index;
        $(id).paletteColorPicker({
          colors: this.ColorList,
          clear_btn: null,
          position: "downside" // default -> 'upside'
        });
        var color_element = document.getElementById(`graph_color_${index}`);
          if(color_element.previousElementSibling != null){
            color_element.previousElementSibling.style.display = "block";
          }
        }
    },

    /* 入力チェック処理 */
    chackInput: function () {
      var ret = false;
      var changedflg = 0;

      //表ではない部分の入力チェック
      var new_graph_name = document.getElementById(`graph_name`).value;
      var new_init_period = document.getElementById(`init_period`).value;
      var new_init_interval = document.getElementById(`init_interval`).value;
      var new_weather_area_name = document.getElementById(`weather_area_name`).value;
      if (new_graph_name !== this.initGraphName) {
        changedflg = 1;
      }
      if (new_init_interval !== this.initInterval) {
        changedflg = 1;
      }
      if (new_init_period !== this.initPeriod) {

        changedflg = 1;
      }
      if (new_weather_area_name !== this.initWeatherAreaName) {
        changedflg = 1;
      }
      //表の部分の入力チェック
      for (let cnt = 0; cnt < this.graphItemSettingsList.length; cnt++) {
        var new_area_name = document.getElementById(`area_name_${cnt}`).value;
        var new_data_code = document.getElementById(`data_code_${cnt}`).value;
        var new_percent_graph_name = document.getElementById(`percent_graph_name_${cnt}`).value;
        var new_percent = document.getElementById(`percent_${cnt}`).value;
        var new_scale_group_name = document.getElementById(`scale_group_name_${cnt}`).value;
        var new_is_tooltip = document.getElementById(`is_tooltip_${cnt}`).checked;
        var new_graph_kind = document.getElementById(`graph_kind_${cnt}`).value;
        var new_graph_color = document.getElementById(`graph_color_${cnt}`).value;

        if (new_area_name !== this.graphItemSettingsList[cnt].area_name) {
          changedflg = 1;
          break;
        }
        if (new_data_code !== this.graphItemSettingsList[cnt].data_code) {
          changedflg = 1;
          break;
        }
        
        if (new_percent_graph_name !== this.graphItemSettingsList[cnt].percent_graph_name) {
          if (new_percent_graph_name !== "") {
            changedflg = 1;
            break;
          }
        }
        if (new_percent != this.graphItemSettingsList[cnt].percent) {
          if (new_percent != 0){
            changedflg = 1;
            break;
          }
        }
        if (new_scale_group_name !== this.graphItemSettingsList[cnt].scale_group_name) {
          changedflg = 1;
          break;
        }
        if (new_is_tooltip !== this.graphItemSettingsList[cnt].is_tooltip) {
          changedflg = 1;
          break;
        }
        if (new_graph_kind !== this.graphItemSettingsList[cnt].graph_kind) {
          changedflg = 1;
          break;
        }
        if (new_graph_color !== this.graphItemSettingsList[cnt].graph_color) {
          changedflg = 1;
          break;
        }
      }
      //フラグ有効でダイヤログ表示
      if (changedflg == 1) {
        if (!confirm('変更を保存せずに画面移動しますか？')) {
          return true;
        }
      }
      return false;
    },

    /* 戻るボタン */
    onBack: function () {
      if (this.chackInput()) {
        return;
      }
      this.$router.push("multi_circuit_graph_list");
    },

    /* スケールグループ設定ボタン */
    onScaleGroup: function () {
      //ここ変える
      if (this.$store.state.graphID == null) {
        alert("スケールグループは、グラフを保存した後、登録可能になります。\nまず、グラフを保存してください。");
        return;
      } else
        if (this.chackInput()) {
          return;
        }
      this.$router.push("multi_circuit_graph_scale_group");
    },

    /* 保存ボタン */
    onSave: function () {
      var changedflg = 0;
      var new_graph_name = document.getElementById(`graph_name`).value;

      // グラフ名称のチェック
      if (new_graph_name === "") {
        changedflg = 1;
      }
      else {
        // 表の必須項目のチェック
        for (let cnt = 0; cnt < this.graphItemSettingsList.length; cnt++) {
          var new_area_name = document.getElementById(`area_name_${cnt}`).value;
          var new_data_code = document.getElementById(`data_code_${cnt}`).value;
          var new_graph_kind = document.getElementById(`graph_kind_${cnt}`).value;
          // エリア名称またはデータコードが未選択の場合、ダイアログを表示
          if (new_area_name !== "") {
            if (new_data_code === "") {
              changedflg = 1;
              break;
            }
          }
            // 工程名称の文字数チェック
            if (new_area_name !== "") {
            let new_percent_graph_name = document.getElementById(`percent_graph_name_${cnt}`).value;
            if (new_percent_graph_name.length > 64) {
              alert('工程名称は64文字以内で入力してください。');
              return;
            }
            // 割合の数値チェック
            let new_percent = document.getElementById(`percent_${cnt}`).value;

            // 割合入力値が数値でない場合
            if (isNaN(new_percent) === true) {
              alert("割合は以下で入力してください。\n・半角数字\n・ピリオド「.」");
              return;
            }
            // 割合の入力値に"e"または"E"が含まれる場合
            else if (this.regex.test(new_percent) === true) {
              alert("割合は以下で入力してください。\n・半角数字\n・ピリオド「.」");
              return;
            }
            // 割合が 0～100 の範囲外の場合
            let fPercent = parseFloat(new_percent);
            if (fPercent < 0 || fPercent > 100) {
              alert("割合は 0～100 の間で入力してください。");
              return
            }

          }
        }
      }
      if (changedflg === 1) {
        alert('必須項目が未入力です。');
        return;
      }
      else {
        this.putGraphItemSetting();
      }
    },

    // 多回路計測グラフ設定変更API実行
    putGraphItemSetting: function () {
      let params = {};
      const multi_circuit_graph_settings_change_list = [];
      const sessionGraphId = this.$store.state.graphID;
      var new_graph_name = document.getElementById(`graph_name`).value;
      var new_init_period = document.getElementById(`init_period`).value;
      var new_init_interval = document.getElementById(`init_interval`).value;
      var new_weather_area_name = document.getElementById(`weather_area_name`).value;
      if (new_weather_area_name === "") {
        new_weather_area_name = null;
      }
      params.graph_id = sessionGraphId;
      if (sessionGraphId === null) {
        params.graph_id = null;
      }
      params.graph_name = new_graph_name;
      params.init_period = new_init_period;
      params.init_interval = new_init_interval;

      params.lclid = null;
      params.amsid = null;
      params.forecast_code = null;
      const selectWeatherArea = this.weatherAreaInfoList.find(item => item.area_name === this.weatherAreaName);
      if (selectWeatherArea) {
        params.lclid = selectWeatherArea.lclid;
        params.amsid = selectWeatherArea.amsid;
        params.forecast_code = selectWeatherArea.forecast_code;
      }

      params.weather_area_name = new_weather_area_name;

      for (let cnt = 0; cnt < this.graphItemSettingsList.length; cnt++) {
        var area_name_check = document.getElementById(`area_name_${cnt}`).value;

        if (area_name_check !== "") {
          var updateGraphSetttingDataList = new Object;
          updateGraphSetttingDataList.graph_item_id = document.getElementById(`graph_item_id_${cnt}`).value;
          updateGraphSetttingDataList.area_name = document.getElementById(`area_name_${cnt}`).value;
          updateGraphSetttingDataList.data_code = document.getElementById(`data_code_${cnt}`).value;
          updateGraphSetttingDataList.percent_graph_name = document.getElementById(`percent_graph_name_${cnt}`).value;
          updateGraphSetttingDataList.percent = document.getElementById(`percent_${cnt}`).value;
          updateGraphSetttingDataList.scale_group_name = document.getElementById(`scale_group_name_${cnt}`).value;
          if (document.getElementById(`scale_group_name_${cnt}`).value === "") {
            updateGraphSetttingDataList.scale_group_name = null;
          }
          updateGraphSetttingDataList.is_tooltip = document.getElementById(`is_tooltip_${cnt}`).checked;
          updateGraphSetttingDataList.graph_kind = document.getElementById(`graph_kind_${cnt}`).value;
          updateGraphSetttingDataList.graph_color = document.getElementById(`graph_color_${cnt}`).value;
          if (this.graphId !== null) {
            updateGraphSetttingDataList.is_delete = document.getElementById(`is_delete_${cnt}`).checked;
          }
          multi_circuit_graph_settings_change_list.push(updateGraphSetttingDataList);
        }
      }
      params.graph_item_settings = multi_circuit_graph_settings_change_list;

      console.log(params);
      if (sessionGraphId === null) {
        this.postGraphMaintenance(params);
      } else {
        this.putGraphMaintenance(params);
      }
    },
    // ページリロード処理
    reload(changedflg) {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
      if (changedflg == 1) {
        this.$store.dispatch("setBeforeAct", 'update');
      }
      else if (changedflg == 2) {
        this.$store.dispatch("setBeforeAct", 'delete');
      }
      else {
        this.$store.dispatch("resetBeforeAct");
      }
    },

    /*カラーパレット*/
    graphColor: function () {
      const str = '#graph_color_';
      for (let i = 0; i < this.getRecordNum; i++) {
        let id = str + i;
        $(id).paletteColorPicker({
          colors: this.ColorList,
          clear_btn: null,
          position: "downside" // default -> 'upside'
        });

      }
    }

  }
}
  ;
</script>

<style scoped>
.input-field {
  background-color: #fff;
  border: 1px solid #5ca1d6;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 5px;
  font-size: 16px;
  font-weight: normal;
}

.checkbox {
  cursor: pointer;
}

.checkbox input[type="checkbox"] {
  margin-right: 10px;
  transform: scale(1.5);
}

.bt-cyan,
.bt-gray {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 120px;
  padding: 10px 20px;
  color: #fff;
  font-size: 16px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.right {
  margin: 0 0 0 auto;
}

.bt-gray {
  background-color: #91a1af;
}

.bt-cyan:hover,
.bt-gray:hover,
.graphlist-bt-cyan:hover {
  background-color: #005cc0;
}

.select-box {
  position: relative;
  display: inline-block;
}

.select-box select {
  border: 1px solid #5ca1d6;
  padding: 5px 40px 5px 20px;
  font-size: 16px;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  outline: none;
}

.select-box select::-ms-expand {
  display: none;
}

.select-box::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  content: "";
  background-color: #9fc8e7;
  pointer-events: none;
  z-index: 99;
}

.select-box::after {
  position: absolute;
  top: -4px;
  bottom: 0;
  right: 6px;
  margin: auto;
  content: "";
  vertical-align: middle;
  width: 8px;
  height: 8px;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  z-index: 99;
}

.gm-select-box {
  position: relative;
  display: inline-block;
}

.gm-select-box select {
  border: 1px solid #5ca1d6;
  padding: 5px;
  font-size: 16px;
  -webkit-appearance: none;
  width: 445px;
  appearance: none;
  cursor: pointer;
  outline: none;
}

.gm-select-box select::-ms-expand {
  display: none;
}

.gm-select-box::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  content: "";
  background-color: #9fc8e7;
  pointer-events: none;
  z-index: 99;
}

.gm-select-box::after {
  position: absolute;
  top: -4px;
  bottom: 0;
  right: 6px;
  margin: auto;
  content: "";
  vertical-align: middle;
  width: 8px;
  height: 8px;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  z-index: 99;
}

.filter {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.filter-condition {
  background-color: #fff;
  border-radius: 8px;
  margin-right: 20px;
  padding: 15px 15px 0;
}

.filter-condition,
.jisseki-download {
  margin-bottom: 20px;
}


.filter-condition-caption {
  border-bottom: 1px solid #5ca1d6;
  margin-bottom: 10px;
  padding-bottom: 5px;
  font-size: 16px;
}

.filter-condition-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.filter-condition-list-item {
  margin-right: 20px;
  margin-bottom: 15px;
}

.button-name {
  margin-bottom: 15px;
}

.filter-condition-list-item:last-child {
  margin-left: auto;
  margin-right: 0;
}

.filter-condition-list-item .select-box {
  margin-left: 5px;
}

.bt-download {
  width: auto;
  min-height: 60px;
  padding: 0 20px;
}

.thead-sub {
  border-top: 1px solid #7c8d9d;
}

.border-right {
  border-right: 1px solid #7c8d9d;
}

#graph-maintenance h2 {
  padding-left: 15px;
  background-color: #5ca1d6;
  color: #fff;
  font-size: 18px;
  height: 45px;
  line-height: 45px;
  border-radius: 4px 4px 0 0;
}

#graph-maintenance table {
  width: 1190px;
}

#graph-maintenance thead tr {
  width: 100%;
  background-color: #bcd8ee;
  text-align: center;
  font-size: 13px;
  line-height: 30px;
}

#graph-maintenance thead th {
  padding: 3px 0;
}

#graph-maintenance tbody td {
  padding: 4px 0;
}

#graph-maintenance tbody tr {
  width: 100%;
  background-color: #fff;
  text-align: center;
}

#graph-maintenance tr:nth-child(2n) td {
  background-color: #f5f5f5;
}

.graphlist-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  background-color: #5ca1d6;
  border-radius: 8px 8px 0 0;
  min-width: 1000px;
  min-height: 45px;
  padding: 0 15px 5px;
}

.graphlist-list-container {
  overflow: visible;
  width: auto;
  max-height: 500px;
  min-width: 1120px;
  margin-bottom: 20px;
}

.graphlist-header-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.graphlist-header-button-item {
  margin: 0 auto;
  margin-left: 10px;
}

.graphlist-header-button-item>p {
  margin-top: 5px;
  color: #fff;
  font-size: 13px;
  text-align: center;
}

.graphlist-header-button .bt {
  display: inline-block;
  background-color: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  color: #444;
  font-size: 14px;
}

.graphlist-header-button .bt:hover {
  opacity: 0.8;
}

#charts .graphlist-header-button .bt {
  font-size: 13px;
}

.graphlist-graphname {
  text-align: left !important;
  text-indent: 1em;
}

.graphlist-list-button-item {
  margin: 0 auto;
}

.graphlist-list-button-item>p {
  margin-top: 5px;
  color: #fff;
  font-size: 13px;
}

.graphlist-bt-cyan {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 90px;
  padding: 5px 10px;
  color: #fff;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.graphlist-table-input-field {
  background-color: #fff;
  border: 1px solid #5ca1d6;
  border-radius: 2px;
  display: inline-block;
  width: 90%;
  box-sizing: border-box;
  padding-left: 3px;
  margin: 5px 0px 5px 0px;
  font-size: 16px;
  font-weight: normal;
}

.table-note {
  margin-top: 10px;
}

.top-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.top-button-item {
  margin: 10px 10px 0;
}

.bottom-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;

  margin-top: 10px;
}

.shop-control .bottom-button {
  margin-bottom: 35px;
}

.bottom-button-item {
  margin: 10px 10px 0;
}

@media screen and (max-width: 1102px) {
  .send-mail-content .bt-cyan {
    width: 100px;
  }
}

.hide {
  display: none;
}

.send-mail-tab {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.send-mail-tab-item+.send-mail-tab-item {
  margin-left: 20px;
}

.send-mail-tab-item .bt {
  display: inline-block;
  background-color: #91a1af;
  border: none;
  border-radius: 4px 4px 0 0;
  width: auto;
  padding: 10px 20px;
  color: #fff;
  font-size: 16px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
}

.center {
  margin-left: auto;
  margin-right: auto;
}

.send-mail-tab-item .bt:hover,
.send-mail-tab-item.active .bt {
  background-color: #005cc0;
}

.send-mail-content {
  background-color: #fff;
  border-radius: 0 8px 8px 8px;
  margin-bottom: 35px;
  padding: 10px 20px 20px;
}

.send-mail-content .top-button .bt-cyan {
  width: 250px;
}

.mail-form-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

@media screen and (max-width: 1102px) {
  .mail-form-item {
    display: block;
  }
}

.mail-form-caption {
  width: 50px;
  margin-top: 20px;
  font-size: 16px;
}

.mail-form-caption label {
  display: block;
  padding: 5px 0;
}

.mail-form-input {
  margin-top: 20px;
}

@media screen and (max-width: 1102px) {
  .mail-form-caption {
    margin-top: 15px;
  }

  .mail-form-input {
    margin-top: 5px;
  }
}

.mail-form .input-field {
  width: 700px;
}

@media screen and (max-width: 1102px) {
  .mail-form-item {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .mail-form .input-field {
    width: 100%;
  }
}

.file {
  width: 750px;
  margin: 20px auto 0;
}

@media screen and (max-width: 1102px) {
  .file {
    width: auto;
  }
}

.file-caption {
  font-size: 16px;
}

.file-data {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.file-name {
  margin: 10px 20px 0 0;
}

.file-button {
  margin-top: 10px;
}

.file-button .bt-gray {
  width: 50px;
}

.file-drop-box {
  border: 1px solid #5ca1d6;
  margin-top: 10px;
  padding: 30px 50px;
  font-size: 16px;
  text-align: center;
}

.auto-setting {
  width: 750px;
  margin: 10px auto 0;
}

@media screen and (max-width: 1102px) {
  .auto-setting {
    width: auto;
  }
}

.auto-setting-form {
  margin: 20px 0 0;
  font-size: 16px;
}

.auto-setting-caption {
  font-size: 16px;
}

/* Container used for styling the custom select, the buttom class adds the bg gradient, corners, etc. */
.gm-dropdown {
  position: relative;
  display: block;
  width: 90%;
  padding: 0;
  margin-right: auto;
  margin-left: auto;
  border: 1px solid #bbb;
  border-radius: 0.3em;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  background: #f3f3f3;
  /* Old browsers */
  background: -moz-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);
  /* FF3.6+ */
  background: -webkit-linear-gradient(top,
      #ffffff 0%,
      #e5e5e5 100%);
  /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(top,
      #ffffff 0%,
      #e5e5e5 100%);
  /* Opera 11.10+ */
  background: -ms-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);
  /* IE10+ */
  background: linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  /* W3C */
}

/* This is the native select, we're making everything the text invisible so we can see the button styles in the wrapper */
.gm-dropdown select {
  width: 100%;
  background: none;
  appearance: none;
  -webkit-appearance: none;
  font-size: 0.75em;
  color: #444;
  padding: 0.3em 1.9em 0em 0.5em;
  line-height: 1.3;
}

.gm-dropdown::after {
  content: "";
  position: absolute;
  width: 9px;
  height: 8px;
  top: 50%;
  right: 0.5em;
  margin-top: -4px;
  z-index: 2;
  background: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 12'%3E%3Cpolygon fill='rgb(102,102,102)' points='8,12 0,0 16,0'/%3E%3C/svg%3E") 0 0 no-repeat;
  /* These hacks make the select behind the arrow clickable in some browsers */
  pointer-events: none;
}

/* Hover style */
.gm-dropdown:hover {
  border: 1px solid #888;
}



.gm-name {
  float: left;
  margin-left: 6%;
}

.gm-bt-gray {
  display: block;
  background-color: #91a1af;
  border: none;
  border-radius: 4px;
  width: 60px;
  padding: 5px 10px;
  color: #fff;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.gm-bt-gray:hover {
  background-color: #005cc0;
}

.gm-desition {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.gm-desition-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  margin-left: auto;
}

.gm-desition-button-item {
  margin-left: 10px;
  margin-bottom: 15px;
}

.gm-footer {
  margin-bottom: 35px;
}

.gm-table,
.gm-table td {
  border: none !important;

  outline: none !important;
}

.gm-table th {
  border: none !important;

  outline: none !important;
}

.gm-normal-table th {
  background-color: #bcd8ee;
  text-align: center;
}

.gm-normal-table th:first-child {
  border-left: none;
}

.gm-normal-table td {
  background-color: #fff;
  padding: 1px;
  text-align: center;
}

.gm-normal-table tbody tr:nth-child(2n) td {
  background-color: #f5f5f5;
}

.gm-normal-table td:first-child {
  border-left: none;
}



.gm-table tbody td {
  padding: 5px 0 !important;
  z-index: 10;
}

.gm-table thead {
  position: sticky;
  top: 0;
  background-color: aqua;
  z-index: 10;
}

.gm-maincont {
  padding-top: 10px;
  z-index: 10;
}

.gm-parent-account-list-container {
  overflow-y: auto;
  width: auto;
  max-height: 420px;
  margin-bottom: 20px;
}

@media screen and (max-width: 1102px) {
  .gm-parent-account-list-container {
    width: 100%;
  }
}

.name-left {
  float: left;
}

.text-box {
  width: 445px;
}

.gmnc-table tbody td {
  padding: 5px 0 !important;
}

.gmc-text-box {
  width: 1000px;
}

.gmc-parent-account-list-container {
  overflow: auto;
  width: auto;
  max-height: 500px;
  margin-bottom: 20px;
}

.gm-bt-scale {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 200px;
  padding: 10px 20px;
  color: #fff;
  font-size: 16px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.gm-bt-scale:hover,
.gm-bt-gray:hover {
  background-color: #005cc0;
}

.gm-bt-scale-position {
  float: left;
}

.gm-shoki {
  float: right;
  margin-bottom: 15px;
}

.gm-shoki-item {
  width: 65px;
}

.gm-table-name {
  width: 350px;
}

/* 工程名称、割合の列幅を指定 */
.gm-percent-graph-name {
  width: 130px;
}

.gm-percent {
  width: 70px;
}

.percent-graph-name {
  width: 100%;
  border: 0.5px solid;
  border-color: black
}

.percent {
  width: 40%;
  border: 0.5px solid;
  border-color: black
}

.gm-graph-type {
  width: 50px;
}

.gm-table-color {
  width: 40px;
}

.gm-table-tooltip {
  width: 90px;
}

.gmc-desition-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  margin-left: auto;
}

.gmc-desition-button-item {
  margin-bottom: 15px;
}

/*エラーメッセージ*/
#err_msg {
  display: inline-block;
  width: 100%;
  margin: 20px auto 0;
  text-align: center;
}

#err_msg span.err_message {
  display: inline-block;
  width: 100%;
  padding: 20px 0 10px 0;
  border: solid 2px #f00;
  margin: 0 auto 10px;
  text-align: center;
  color: #f00;
  background: #fff;
}

span.err_message {
  /* display: inline-block; */
  width: 100%;
  padding: 20px 0 10px 0;
  /* border: solid 2px #f00; */
  margin: 0 auto 10px;
  text-align: center;
  color: #f00;
  /* background: #fff; */
}

div.err_message {
  /* display: inline-block; */
  /* width: 100%; */
  /* padding: 20px 0 10px 0; */
  /* border: solid 2px #f00; */
  /* margin: 0 auto 10px; */
  text-align: left;
  color: #f00;
  /* background: #fff; */
}

.interval-with-header {
  padding-top: 60px;
}
</style>